module.exports = __webpack_public_path__ + "img/ruai-1.e2177dfa.png";